import '@fortawesome/fontawesome-free/css/all.min.css';
import 'bootstrap-css-only/css/bootstrap.min.css';
import 'mdbvue/lib/css/mdb.min.css';
import Vue from 'vue';
import Notify from 'mdbvue/lib/components/Notify';
import * as mdbvue from 'mdbvue';
import App from './App.vue';
import router from './router';
import store from './store';

Vue.config.productionTip = false;
Vue.use(Notify);

Object.keys(mdbvue).forEach((component) => {
  Vue.component(component, mdbvue[component]);
});

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
